import { render, staticRenderFns } from "./form-two-factory.vue?vue&type=template&id=66a72494&"
import script from "./form-two-factory.vue?vue&type=script&lang=js&"
export * from "./form-two-factory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports